import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, ElementRef, Input, NgZone, OnChanges, OnDestroy, OnInit, signal, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';

import { Column } from '../data-table.interfaces';
import { ComponentInsertorDirective } from './component-insertor.directive';

@Component({
    selector: 'ig-table-component-insertor',
    styleUrls: ['./component-insertor.component.scss'],
    template: `<ng-template igTableComponentHost></ng-template>`,
    standalone: false
})
export class ComponentInsertorComponent implements OnDestroy, OnChanges, OnInit, AfterViewInit {

  @ViewChild(ComponentInsertorDirective, {static: false}) insertionPoint!: ComponentInsertorDirective;

  @Input() row?: any;
  @Input() column?: Column;
  @Input() dataChangeSubject?: Subject<any>;

  rowSignal = signal<any>({ ...this.row });

  componentRef?: ComponentRef<any>;
  private destroyed$ = new Subject<void>();
  private changeDetectorInterval?: number;
  private lastRow: any;

  constructor(private readonly ref: ChangeDetectorRef, private elRef: ElementRef, private readonly zone: NgZone) { }

  ngOnInit() {
    this.rowSignal.set({ ...this.row });

    this.changeDetectorInterval = window.setInterval(() => {
      if (this.elRef.nativeElement.innerHTML === '') {
        this.ref.markForCheck();

      } else {
        window.clearInterval(this.changeDetectorInterval);
        this.changeDetectorInterval = undefined;
      }
    }, 100);

    if (this.dataChangeSubject) {
      this.dataChangeSubject.pipe(
        takeUntil(this.destroyed$),
        debounceTime(100),
      ).subscribe(() => {
        if (this.lastRow === undefined || !_.isEqual(this.row, this.lastRow)) {
          this.ref.markForCheck();

          if (this.componentRef?.instance?.ngOnChanges) {
            const changes: SimpleChanges = {
              row: new SimpleChange(this.lastRow, this.row, this.lastRow === undefined)
            };

            this.componentRef.instance.ngOnChanges(changes);
          }
          if (this.componentRef?.changeDetectorRef) {
            this.componentRef.changeDetectorRef.markForCheck();
          }

          this.lastRow = _.cloneDeep(this.row);
        }

      });
    }
  }

  ngAfterViewInit() {
    if (this.column?.component) {

      const viewContainerRef = this.insertionPoint.viewContainerRef;
      viewContainerRef.clear();

      //const componentRef = viewContainerRef.createComponent(this.column.component);

      this.zone.onStable.pipe(
        takeUntil(this.destroyed$),
        take(1)
      ).subscribe(() => {
        this.componentRef = viewContainerRef.createComponent(this.column!.component!);
        this.componentRef.instance.row = this.row;
        this.componentRef.instance.rowSignal = this.rowSignal;
        if (this.column!.componentProperties) {
          _.assign(this.componentRef.instance, this.column!.componentProperties);
        }
        this.componentRef.changeDetectorRef.markForCheck();
      });
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['row'] && this.componentRef) {
      this.rowSignal.set({ ...this.row });
      window.setTimeout(() => {
        this.componentRef!.instance.row = this.row;
        this.componentRef!.changeDetectorRef.markForCheck();
      });
    }
  }

  ngOnDestroy() {
    if (this.changeDetectorInterval) {
      window.clearInterval(this.changeDetectorInterval);
    }
    this.destroyed$.next();
    this.destroyed$.complete();

    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

}
